var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseSelect',{attrs:{"value":_vm.value,"options":_vm.items,"placeholder":_vm.$tFilter('All areas'),"textKey":"title","cancelable":"","filterable":false,"loading":_vm.loading},on:{"input":_vm.onInput}})}
var staticRenderFns = []

export { render, staticRenderFns }